export default "__VITE_ASSET__0d4c5207__"